var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgProfilePhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#profile-phone_svg__a)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.592.435c8.01 1.976 12.948 10.146 10.973 18.157-1.976 8.01-10.146 12.948-18.157 10.973C3.397 27.588-1.541 19.418.435 11.407 2.411 3.398 10.581-1.54 18.592.435Z",
  fill: "#DC632A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.75 13.55c.817-1.58 1.102-3.354.16-4.955-.364-.62-.924-1.307-1.66-1.508-.76-.208-1.715-.06-2.014.646-.24.564-1.32 2.908-1.36 3.292a.646.646 0 0 0 .075.373c.333.64 1.175 1.383 1.293 1.69a.524.524 0 0 1-.074.483c-1.23 2.07-3.635 4.285-5.826 5.37a.566.566 0 0 1-.5.048c-.311-.13-1.034-.986-1.674-1.34a.712.712 0 0 0-.381-.091c-.4.02-2.866.945-3.459 1.148-.746.254-.947 1.172-.77 1.92.17.723.85 1.3 1.468 1.685 1.595.993 3.441.81 5.106.1 3.538-1.504 7.849-5.444 9.616-8.862Z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "profile-phone_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "matrix(-1 0 0 1 30 0)",
  d: "M0 0h30v30H0z"
})))));
export default SvgProfilePhone;